import { render } from "./NavBarActions.vue?vue&type=template&id=8f470c96"
import script from "./NavBarActions.vue?vue&type=script&lang=js"
export * from "./NavBarActions.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__